export enum modalTypes {
    youFirstManager = 'yf',
    demandes = 'request',
    response = 'response',
    service = 'service',
    prelevement = 'prelevement',
    cguModal = 'cguModal',
    edle = 'edle',
    edls = 'edls',
}
